import { createGlobalState, useCallback } from '~libs.ui.react';

import { VisitId } from '../types';

import {
   PatientEntitlementToMedicalServiceStatus,
   PatientEntitlementToMedicalServiceStatusGetter,
   PatientEntitlementToMedicalServiceStatusGlobalState,
   PatientEntitlementToMedicalServiceStatusSetter,
} from './patientEntitlementToMedicalServiceStatusGlobalState.types';

const usePatientEntitlementToMedicalServiceStatusGlobalState = createGlobalState<PatientEntitlementToMedicalServiceStatusGlobalState>(
   new Map()
);

export const useGetPatientEntitlementToMedicalServiceStatus: PatientEntitlementToMedicalServiceStatusGetter = (
   appointmentId
) => {
   const [
      visitPatientEntitlementToMedicalServiceStatusGlobalState,
   ] = usePatientEntitlementToMedicalServiceStatusGlobalState();

   const status = visitPatientEntitlementToMedicalServiceStatusGlobalState.get(appointmentId);
   if (!status) {
      // eslint-disable-next-line prettier/prettier
      throw new Error('Don\'t use patient entitlement to medical service before value initialization.');
   }
   return status;
};

export const useSetPatientEntitlementToMedicalServiceStatus: PatientEntitlementToMedicalServiceStatusSetter = () => {
   const [
      patientEntitlementToMedicalServiceStatusGlobalState,
      setPatientEntitlementToMedicalServiceStatusGlobalState,
   ] = usePatientEntitlementToMedicalServiceStatusGlobalState();

   return useCallback(
      (visitId, patientEntitlementToMedicalServiceStatus) => {
         setPatientEntitlementToMedicalServiceStatusGlobalState(
            new Map([
               ...patientEntitlementToMedicalServiceStatusGlobalState,
               ...([[visitId, patientEntitlementToMedicalServiceStatus]] as Array<
                  [VisitId, PatientEntitlementToMedicalServiceStatus]
               >),
            ])
         );
      },
      [patientEntitlementToMedicalServiceStatusGlobalState, setPatientEntitlementToMedicalServiceStatusGlobalState]
   );
};
